import type { MenuProps } from "@mui/base/Menu";
import BaseMenu from "@mui/base/Menu";
import type { FunctionComponent } from "react";

import { ListboxStyled } from "./styles";

export const Menu: FunctionComponent<MenuProps> = ({ children, ...props }) => {
  const listbox = props.slots?.listbox ?? ListboxStyled;

  return (
    <BaseMenu {...props} slots={{ listbox }}>
      {children}
    </BaseMenu>
  );
};
